import Helpers from "./Helpers";

class MobileFilter {
  constructor() {
    this.button = document.querySelector('#filter-mobile-button');

    if (this.button) {
      this.init();
    }
  }

  init() {
    this.filters = document.querySelectorAll('.blog__filters');

    this.button.addEventListener('click', event => {
      const el = event.currentTarget;

      this.filters.forEach(filter => {
        Helpers.slideToggle(filter);
      });

      el.classList.toggle('filter-mobile-button--selected');
    });

    /* Media query to always show filters on desktop */
    window.matchMedia('(max-width: 768px)')
      .addEventListener("change", event => {

        if (this.filters.length) {

          /* the viewport is 768 pixels wide or less */
          if (event.matches) {
            this.filters.forEach(filter => {
              filter.style.display = 'none';
            });
          }
          /* the viewport is more than than 768 pixels wide */
          else {
            this.filters.forEach(filter => {
              filter.style.display = 'block';
            });

            this.button.classList.remove('filter-mobile-button--selected');
          }
        }

      });
  }
}

export default MobileFilter;
